import Auth0Client from "@auth0/auth0-spa-js/dist/typings/Auth0Client";
import createAuth0Client from "@auth0/auth0-spa-js";
import {audience, clientId, domain} from "@/auth_config.json";

export class Challenge {
    constructor(public title: string,public description: string,public topic:string,public points:number) {
    }
}
export function getDailyChallenges(): Challenge[] {
    const challenges :Challenge[] = [];

    challenges.push(new Challenge("1x1","Trainiere des kleine 1x1","1x1Table",10));
    challenges.push(new Challenge("Plus","Trainiere Trainere technicken für das addieren von Zahlen","Addition",5));

    return challenges;
}
